<template>
  <form class="calculator__form" action="#">
    <h3 class="calculator__section-heading heading-reset">
      Вы приводите клиента, которому необходим сотрудник:
    </h3>
    <fieldset class="calculator__section schedule">
      <input
        id="parttime"
        class="schedule__radio"
        type="radio"
        name="schedule"
        value="1"
        v-model.number="scheduleId"
      />
      <label class="schedule__label schedule-left" for="parttime">
        на проект с почасовой оплатой
      </label>

      <input
        id="fulltime"
        class="schedule__radio"
        type="radio"
        name="schedule"
        value="2"
        v-model.number="scheduleId"
      />
      <label class="schedule__label schedule-right" for="fulltime">
        в штат на полную занятость
      </label>
    </fieldset>

    <div v-if="scheduleId === 2" class="calculator__form-container props">
      <fieldset class="calculator__section">
        Количество вакансий, которые будут закрыты за год:
        <input
          class="props__input amount"
          type="text"
          name="amount"
          maxlength="3"
          v-model="formatVacancyAmount"
        />
      </fieldset>

      <fieldset class="calculator__section">
        Средняя стоимость подбора:
        <input
          class="props__input price"
          type="text"
          name="price"
          maxlength="7"
          v-model="formatFullTimePrice"
        />
        рублей
      </fieldset>
    </div>

    <div v-else-if="scheduleId === 1" class="calculator__form-container props">
      <fieldset class="calculator__section">
        Стоимость часа специалиста для клиента:
        <input
          class="props__input price"
          type="text"
          name="price"
          maxlength="5"
          v-model="formatPricePerHour"
        />
        рублей
      </fieldset>
      <p class="calculator__section p-reset">
        Наш специалист работает у приведённого вами клиента в течение года или более
      </p>
    </div>

    <p class="calculator__profit-text">
      Вы заработаете
      <span class="calculator__profit">{{ profitSum | numberFormat }}</span>
      рублей.
    </p>
  </form>
</template>

<style scoped>
.calculator__form {
  width: 100%;
  font-weight: 500;
}

.calculator__form-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px;
  margin-bottom: 55px;
  background-color: var(--white);
  border: 1px solid #999;
  border-top-width: 2px;
  box-shadow: 0px 4px 8px 0px rgba(34, 60, 80, 0.2);
}

.calculator__section {
  padding: 0;
  margin: 0;
  border: none;
  text-align: left;
}

.calculator__section-heading {
  margin-bottom: 44px;
  font-weight: 500;
}

.schedule {
  position: relative;
  display: flex;
}

.schedule__radio {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.schedule__label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
  position: relative;
  width: calc(50% - 10px);
  text-align: center;
  color: #999;
  border: 2px solid rgb(207, 207, 207);
  border-bottom: none;
  background-color: #e7e4e4;
  cursor: pointer;
}

.schedule__label:not(:last-child) {
  margin-right: 20px;
}

.schedule__label::before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: transparent;
}

.schedule__label::after {
  content: "";
  position: absolute;
  top: -5px;
  left: -3px;
  right: -3px;
  height: 5px;
  background-color: transparent;
  transition: background-color 0.2s linear;
}

.schedule__label:hover::after {
  background-color: #999;
}

.schedule__radio:checked + .schedule__label {
  background-color: #fff;
  border-color: #999;
  border-bottom: none;
  color: #000;
  box-shadow: 0px -6px 8px 0px rgba(34, 60, 80, 0.2);
}

.schedule__radio:checked + .schedule-left {
  border-left-width: 1px;
}

.schedule__radio:checked + .schedule-right {
  border-right-width: 1px;
}

.schedule__radio:checked + .schedule__label::after {
  background-color: var(--main);
}

.schedule__radio:checked + .schedule__label::before {
  background-color: #fff;
}

.props > .calculator__section:not(:last-child) {
  margin-bottom: 40px;
}

.props__input {
  padding: 0;
  padding-top: 3px;
  border: none;
  border-bottom: 2px solid var(--black);
  border-color: #000;
  outline: none;
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 1em;
  line-height: 1em;
  transition: border-color 0.2s linear;
}

.props__input:hover {
  border-color: var(--main);
}

.props__input.amount {
  width: 50px;
  text-align: center;
}

.props__input.price {
  width: 110px;
  text-align: center;
}

.calculator__profit {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.calculator__profit-text {
  font-size: 1.2rem;
}

@media (max-width: 960px) {
  .calculator__form {
    text-align: center;
  }
}

@media (max-width: 769px) {
  .props__input.amount {
    width: 35px;
  }

  .props__input.price {
    width: 90px;
  }
}

@media (max-width: 600px) {
  .calculator__section-heading {
    margin-bottom: 35px;
  }

  .calculator__form-container {
    padding: 20px;
    margin-bottom: 30px;
  }

  .schedule__label {
    padding: 10px;
    width: calc(50% - 5px);
  }

  .schedule__label:not(:last-child) {
    margin-right: 10px;
  }

  .props > .calculator__section:not(:last-child) {
    margin-bottom: 25px;
  }

  .props__input.amount {
    width: 30px;
  }

  .props__input.price {
    width: 70px;
  }
}
</style>

<script>
import numberFormat from '@/helpers/numberFormat'
export default {
  data () {
    return {
      scheduleId: 2,

      fullTimePrice: 300000,
      pricePerHour: 2800,
      vacancyAmount: 5,

      profit: 0
    }
  },
  computed: {
    profitSum () {
      return this.profit
    },
    formatFullTimePrice: {
      get () {
        return this.fullTimePrice
      },
      set (value) {
        this.fullTimePrice = this.formatValue(value)
      }
    },
    formatPricePerHour: {
      get () {
        return this.pricePerHour
      },
      set (value) {
        this.pricePerHour = this.formatValue(value)
      }
    },
    formatVacancyAmount: {
      get () {
        return this.vacancyAmount
      },
      set (value) {
        this.vacancyAmount = this.formatValue(value)
      }
    }
  },
  methods: {
    calcProfit () {
      if (this.scheduleId === 1) {
        this.profit = parseInt(this.pricePerHour * 172 * 12 * 0.1)
      } else if (this.scheduleId === 2) {
        this.profit = parseInt(this.fullTimePrice * this.vacancyAmount * 0.1)
      } else {
        this.profit = 0
      }
    },
    formatValue (value) {
      const trimValue = value.trim()
      if (trimValue.length <= 0) return 0

      const regexp = /[^\d]/g
      const formatValue = value.replace(regexp, '')

      if (!formatValue) return 0
      else return formatValue
    },
    checkQueryParams () {
      const params = new URL(document.location).searchParams
      return params.has('swd')
    }
  },
  created () {
    this.scheduleId = this.checkQueryParams() ? 1 : 2
  },
  watch: {
    scheduleId: {
      handler () {
        this.calcProfit()
      },
      immediate: true
    },
    fullTimePrice () {
      this.calcProfit()
    },
    pricePerHour () {
      this.calcProfit()
    },
    vacancyAmount () {
      this.calcProfit()
    }
  },
  filters: {
    numberFormat
  }
}
</script>
